import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardService } from '../../modules/services/dashboard.service';
import { StatCard, MonthlyRegistration, VendorCategory, ActivityItem } from '../../models/dashboard.model';
import { StatCardComponent } from '../stat-card/stat-card.component';
import { MonthlyChartComponent } from '../monthly-chart/monthly-chart.component';
import { CategoryChartComponent } from '../category-chart/category-chart.component';
import { ActivityFeedComponent } from '../activity-feed/activity-feed.component';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    StatCardComponent,
    MonthlyChartComponent,
    CategoryChartComponent,
    ActivityFeedComponent
  ],
  template: `
    <div class="dashboard">
      <!-- Stats Row -->
      <div class="stats-grid">
        <app-stat-card
          *ngFor="let stat of statCards; let i = index"
          [card]="stat"
          [style.animation-delay]="i * 0.1 + 's'">
        </app-stat-card>
      </div>

      <!-- Charts Row -->
      <div class="charts-grid">
        <div class="chart-col">
          <app-monthly-chart [data]="monthlyData"></app-monthly-chart>
        </div>
        <div class="chart-col">
          <app-category-chart [categories]="categories"></app-category-chart>
        </div>
      </div>

      <!-- Activity Row -->
      <div class="activity-row">
        <app-activity-feed [activities]="activities"></app-activity-feed>
      </div>
    </div>
  `,
  styles: [`
    .dashboard {
      display: flex;
      flex-direction: column;
      gap: 24px;
      max-width: 1400px;
    }

    .stats-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 20px;
    }

    .charts-grid {
      display: grid;
      grid-template-columns: 1.2fr 0.8fr;
      gap: 20px;
    }

    .chart-col {
      min-width: 0;
    }

    .activity-row {
      max-width: 100%;
    }

    @media (max-width: 1200px) {
      .charts-grid {
        grid-template-columns: 1fr;
      }
    }

    @media (max-width: 768px) {
      .stats-grid {
        grid-template-columns: 1fr;
      }

      .charts-grid {
        grid-template-columns: 1fr;
      }
    }
  `]
})
export class DashboardComponent implements OnInit {
  statCards: StatCard[] = [];
  monthlyData: MonthlyRegistration[] = [];
  categories: VendorCategory[] = [];
  activities: ActivityItem[] = [];

  constructor(private dashboardService: DashboardService) {}

  ngOnInit() {
    this.loadDashboardData();
  }

  private loadDashboardData() {
    this.dashboardService.getStatCards().subscribe(stats => {
      this.statCards = stats;
    });

    this.dashboardService.getMonthlyRegistrations().subscribe(data => {
      this.monthlyData = data;
    });

    this.dashboardService.getVendorCategories().subscribe(cats => {
      this.categories = cats;
    });

    this.dashboardService.getRecentActivities().subscribe(acts => {
      this.activities = acts;
    });
  }
}
